import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  getCurrentDate,
  getCurrentMonthFirstDate,
  timeToSeconds2,
} from "../../Utilitie";

const ADRMBlockPositionUpdate = () => {
  const [entry, setEntry] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const keys = [
    "id",
    "block_date",
    "dept",
    "total_corridor_blocks_agreed",
    "total_corridor_hours_agreed",
    "total_corridor_blocks_granted",
    "total_corridor_hours_granted",
    "created_by",
  ];

  const fetchData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getBlockDataAdrmDaily?fromDt=${startDate}&toDt=${endDate}`
      );
      if (response.data.status === "ok" && Array.isArray(response.data.data)) {
        const transformed = response.data.data.map((item) => ({
          ...item,
          total_corridor_hours_agreed: secondsToTimeObject(
            item.total_corridor_hours_agreed
          ),
          total_corridor_hours_granted: secondsToTimeObject(
            item.total_corridor_hours_granted
          ),
        }));
        setEntry(transformed);
      } else {
        setEntry([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const secondsToTimeObject = (seconds) => {
    const hrs = Math.floor((+seconds || 0) / 3600);
    const mins = Math.floor(((+seconds || 0) % 3600) / 60);
    return { hours: hrs.toString(), minutes: mins.toString() };
  };

  const handleChange = (rowIndex, key, value) => {
    const updated = [...entry];
    updated[rowIndex] = { ...updated[rowIndex], [key]: value };
    setEntry(updated);
  };

  const handleHourMinuteChange = (rowIndex, key, field, value) => {
    if (field === "minutes" && value > 59) return;
    const updated = [...entry];
    updated[rowIndex] = {
      ...updated[rowIndex],
      [key]: {
        ...updated[rowIndex][key],
        [field]: value,
      },
    };
    setEntry(updated);
  };

  const correctFormatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toISOString().slice(0, 10).replace("T", " ");
  };

  const handleSubmit = async () => {
    const finalData = entry
      .map((en) => {
        let forDate = en.created_date;
        if (forDate) {
          forDate = correctFormatDate(forDate);
        }

        return {
          ...en,
          block_date: new Date(en.block_date).toISOString().slice(0, 10),
          created_date: forDate,
          total_corridor_hours_agreed: timeToSeconds2(
            `${en.total_corridor_hours_agreed.hours || "0"}:${
              en.total_corridor_hours_agreed.minutes || "0"
            }`
          ),
          total_corridor_hours_granted: timeToSeconds2(
            `${en.total_corridor_hours_granted.hours || "0"}:${
              en.total_corridor_hours_granted.minutes || "0"
            }`
          ),
        };
      })
      .map(
        ({
          update_time_stamp,
          percent_comp_block,
          percent_hours_block,
          created_date,
          ...rest
        }) => rest
      );

    try {
      await axios.put(
        `${urlPrefixBlock}updateBlockPositionAdrmDaily`,
        finalData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      alert("Data updated successfully!");
    } catch (err) {
      console.error("Update error:", err.response?.data || err);
      alert("Update failed.");
    }
  };

  return (
    <div className="papaDiv">
      <h5 className="mb-1 bg-dark text-white text-center fw-bold p-2">
        Update Data In ADRM Daily Block Position
      </h5>
      <div className="d-flex justify-content-center gap-3 mb-1 align-items-center bg-dark">
        <div className="d-flex align-items-center p-2">
          <b>From </b>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="mx-1"
          />
          <b>To </b>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="mx-1"
          />
          <button className="btn btn-sm btn-outline-light" onClick={fetchData}>
            Fetch
          </button>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-danger">Error loading data</p>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-bordered table-striped mb-4">
              <thead className="table-dark text-center align-middle">
                <tr>
                  <th>Sr No.</th>
                  {keys.map((key, i) => {
                    if (key === "id" || key === "created_by") return null;
                    return (
                      <th key={i}>{key.toUpperCase().replace(/_/g, " ")}</th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {entry.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{rowIndex + 1}</td>
                    {keys.map((key, colIndex) => {
                      if (key === "id" || key === "created_by") return null;

                      if (key === "block_date") {
                        return (
                          <td key={colIndex}>
                            <input
                              type="date"
                              disabled
                              className="form-control"
                              value={
                                row[key]
                                  ? row[key].slice(0, 10)
                                  : new Date().toISOString().slice(0, 10)
                              }
                            />
                          </td>
                        );
                      }

                      if (key === "dept") {
                        return <td key={colIndex}>{row[key]}</td>;
                      }

                      if (
                        key === "total_corridor_hours_agreed" ||
                        key === "total_corridor_hours_granted"
                      ) {
                        return (
                          <td key={colIndex}>
                            <div className="d-flex justify-content-center">
                              <input
                                type="number"
                                placeholder="HH"
                                className="w-25 form-control form-control-sm "
                                min="0"
                                value={row[key]?.hours || ""}
                                onChange={(e) =>
                                  handleHourMinuteChange(
                                    rowIndex,
                                    key,
                                    "hours",
                                    e.target.value
                                  )
                                }
                              />
                              <span className="fw-bolder m-2">:</span>

                              <input
                                type="number"
                                placeholder="MM"
                                className="w-25 form-control form-control-sm"
                                min="0"
                                max="59"
                                value={row[key]?.minutes || ""}
                                onChange={(e) =>
                                  handleHourMinuteChange(
                                    rowIndex,
                                    key,
                                    "minutes",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </td>
                        );
                      }

                      return (
                        <td key={colIndex}>
                          <input
                            type="number"
                            className="form-control"
                            value={row[key] || ""}
                            onChange={(e) =>
                              handleChange(rowIndex, key, e.target.value)
                            }
                          />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-4">
            <button
              className="btn btn-outline-success m-2 px-5"
              onClick={handleSubmit}
            >
              Update
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ADRMBlockPositionUpdate;
